import { rest } from "msw";
import type { DeviceAdapterType } from "../adapters/DeviceAdapters.ts";
import type { DomainConfig } from "../config.ts";
import { DeviceStatus } from "../schemas/DeviceSchemas.ts";
import { DeviceSchema, type DeviceType } from "../schemas/DeviceSchemas.ts";
import {
  getApiUrlWithEndpoint,
  type BuildMockHandlersType,
} from "./handlers.ts";
import { DomainFaker, DomainMock } from "./utils.ts";

export const DeviceMock = new DomainMock<DeviceType, typeof DeviceSchema>(
  DeviceSchema,
  () => {
    const createdAt = DomainFaker.en.date.past();

    return {
      id: DomainFaker.en.string.uuid(),
      name: DomainFaker.en.string.alpha(10),
      status: DomainFaker.en.helpers.arrayElement(Object.values(DeviceStatus)),
      type_id: DomainFaker.en.string.alpha(10),
      facility_id: DomainFaker.en.string.uuid(),
      attributes: {
        provider: DomainFaker.en.string.alpha(10),
      },
      custom_attributes: {
        [DomainFaker.en.string.alpha(10)]: DomainFaker.en.string.alpha(10),
      },
      facility: {
        id: DomainFaker.en.string.uuid(),
        name: DomainFaker.en.string.alpha(10),
      },
      measurement_types: [
        DomainFaker.en.string.alpha(10),
        DomainFaker.en.string.alpha(10),
      ],
      type: {
        id: DomainFaker.en.string.uuid(),
        name: DomainFaker.en.string.alpha(10),
      },
      created_at: createdAt.toISOString(),
      created_by: DomainFaker.en.string.uuid(),
      updated_at: DomainFaker.en.date
        .between({ from: createdAt, to: new Date() })
        .toISOString(),
      updated_by: DomainFaker.en.string.uuid(),
    };
  },
  true
).fix();

export const buildDeviceHandlers: BuildMockHandlersType<DeviceAdapterType> = (
  configData: DomainConfig
) => {
  const { nodeURL: url } = configData;

  return {
    createOne: rest.post(
      getApiUrlWithEndpoint({
        url,
        version: 1,
        endpoint: "/devices",
      }),
      (_, res, ctx) => {
        const data = DeviceMock.generate();

        return res(ctx.status(200), ctx.json(data));
      }
    ),
  };
};
